import { Box } from '@chakra-ui/react';
import Image from 'next/image';
import { type FC } from 'react';
import type { LogoIdnConnectProps } from './types';

export const LogoIdnConnect: FC<LogoIdnConnectProps> = ({ ...props }) => {
  return (
    <Box data-testid="logo_idnConnect" display="flex" alignItems="center" justifyContent="center" mb="24px" {...props}>
      <Image data-testid="logo_idnConnect_image" width="165px" height="24px" src="/assets/images/logo_idn_connect.svg" alt="IDN Connect Logo" />
    </Box>
  )
}
